module.exports = "/images/ny-street-7.jpg";